// Velo API Referansı: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(function () {

	// Velo framework API'yi kullanarak JavaScript kodunuzu buraya yazın

	// Merhaba Dünya mesajını yazdırın:
	// console.log("Merhaba dünya!");

	// Sayfa ögelerinde fonksiyonlar çağırın, örneğin:
	// $w("#button1").label = "Buraya tıkla!";

	// Kodunuzu çalıştırmak için Çalıştır ögesine ya da Önizle'ye tıklayın.

});